import React from 'react';
import HelpApiLayout from '../../../../components/layout/HelpApiLayout';
import HelpSidebar from '../../../../components/layout/HelpSidebar';
import ArticleViewer from '../../components/ArticleViewer';
import { PUBLIC_ROUTES } from '../../../../constants/routes';
import '../getting-started/HelpCategoryPage.css';

/**
 * Notification Preferences Article Page
 */
const Notifications = () => {
  return (
    <HelpApiLayout type="help" sidebar={<HelpSidebar />}>
      <div className="help-category-page">
        <div className="help-category-container">
          <main className="help-category-main">
            <ArticleViewer 
              title="Notification Preferences"
              showQA={true}
              articleId="notifications"
            >
              <div className="article-content">
                <p>
                  Customize how and when you receive notifications to stay informed without
                  being overwhelmed.
                </p>
                
                <h2>Notification Types</h2>
                <p>Control notifications for:</p>
                <ul>
                  <li><strong>Split Updates:</strong> When splits are created, updated, or settled</li>
                  <li><strong>Payment Alerts:</strong> When you receive or send payments</li>
                  <li><strong>Friend Activity:</strong> When friends join splits or make payments</li>
                  <li><strong>Wallet Activity:</strong> Shared wallet transactions and updates</li>
                  <li><strong>Reminders:</strong> Payment reminders and due dates</li>
                </ul>

                <h2>Notification Channels</h2>
                <p>Choose how you want to receive notifications:</p>
                <ul>
                  <li><strong>Push Notifications:</strong> Real-time alerts on your device</li>
                  <li><strong>Email:</strong> Daily or weekly summaries</li>
                  <li><strong>SMS:</strong> Important alerts via text message</li>
                  <li><strong>In-App:</strong> Notifications within the WeSplit app</li>
                </ul>

                <h2>Quiet Hours</h2>
                <p>
                  Set quiet hours when you don't want to receive notifications. You'll still
                  see them when you open the app, but won't be interrupted.
                </p>

                <h2>Priority Notifications</h2>
                <p>
                  Mark certain notification types as priority to always receive them, even during
                  quiet hours.
                </p>
              </div>
            </ArticleViewer>
          </main>
        </div>
      </div>
    </HelpApiLayout>
  );
};

export default Notifications;
